import * as React from 'react'

const FooterRegister: React.FC  = () => null
export default FooterRegister
